var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.tooltip)?_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('div',_vm._g({staticClass:"ellipsis-text",style:(_vm.style)},on),[_vm._t("default")],2)]}}],null,true)},[_vm._t("default")],2):_c('div',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }